import CompanyTagsSection from './CompanyTagsSection'

export default CompanyTagsSection
